import { render, staticRenderFns } from "./Keyword.vue?vue&type=template&id=9c5f353c&scoped=true&"
import script from "./Keyword.vue?vue&type=script&lang=ts&"
export * from "./Keyword.vue?vue&type=script&lang=ts&"
import style0 from "./Keyword.vue?vue&type=style&index=0&id=9c5f353c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5f353c",
  null
  
)

export default component.exports